import { useEffect, useState } from 'react';
import { api } from '../api';

/**
 * Lightweight, polled counts for sidebar nav items. Re-fetched every 30s
 * so the badges feel live without flooding the backend. Errors silently
 * fall back to undefined (no badge) rather than breaking the sidebar.
 */
export function useSidebarCounts(): Record<string, number | undefined> {
  const [counts, setCounts] = useState<Record<string, number | undefined>>({});
  useEffect(() => {
    let alive = true;
    const refresh = async () => {
      const [flows, mappings, valueMappings, runtimes, connections] = await Promise.all([
        api.listFlows().catch(() => null),
        api.messageMappings().catch(() => null),
        api.valueMappings().catch(() => null),
        api.listRuntimes().catch(() => null),
        api.listConnections().catch(() => null),
      ]);
      if (!alive) return;
      setCounts({
        flows: flows ? flows.length : undefined,
        mappings: mappings ? mappings.length : undefined,
        schemas: valueMappings ? valueMappings.length : undefined,
        envs: runtimes ? runtimes.length : undefined,
        connections: connections ? connections.length : undefined,
      });
    };
    void refresh();
    const t = setInterval(() => void refresh(), 30_000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, []);
  return counts;
}
